import {Component, OnInit, Input, EventEmitter} from '@angular/core';
import {FormGroupDirective, ControlContainer, Validators, UntypedFormGroup, UntypedFormControl, AbstractControl} from '@angular/forms';
import { Individual } from '../../model/individual';
import { EqualValidatorDirective } from './equal-validator.directive';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PasswordComponent implements OnInit {

  @Input() individual: Individual;
  @Input() isSaving: boolean;
  @Input() form: UntypedFormGroup;
  @Input() OnSave: EventEmitter<Individual>;

  group: UntypedFormGroup;

  get cst_new_password(): AbstractControl {
    return this.group.get('cst_new_password');
  }

  get cst_new_password_confirm(): AbstractControl {
    return this.group.get('cst_new_password_confirm');
  }

  get hasError(): boolean {
    return (this.cst_new_password.invalid || this.cst_new_password_confirm.invalid)
      && (
        (this.cst_new_password.dirty || this.cst_new_password.touched)
        && (this.cst_new_password_confirm.dirty || this.cst_new_password_confirm.touched)
      );
  }

  constructor() { }

  ngOnInit() {
    const cst_new_password = new UntypedFormControl(this.individual.cst_new_password, [ Validators.required]);
    const cst_new_password_confirm = new UntypedFormControl(this.individual.cst_new_password_confirm, [ Validators.required]);

    this.group = new UntypedFormGroup({ cst_new_password, cst_new_password_confirm });
    this.form.addControl('password', this.group);

    this.OnSave.subscribe(individual => this.Save(individual));
  }

  Save(individual: Individual) {
    const values = this.group.value;

    Object.assign(individual, values);
  }

}
